/** GSS heatmap date range limit — set enabled: false to restore DateRangeChooser. */
export const SPOOFING_GSS_DATE_RANGE_LIMIT = {
	enabled: true,
	maxDays: 5,
} as const;
